export default "__VITE_ASSET__BxqGDRJV__"